/**
 * Сохраняет клавиатурную позицию после read/unread в списке и popup.
 * Не открывает панели и не отбирает фокус, если пользователь уже ушёл дальше.
 */

// Вызывать до запроса; возвращённую функцию — после обновления DOM.
export function createNotificationFocusRestorer(trigger, panel) {
  const hadFocus = Boolean(trigger && document.activeElement === trigger);
  return () => {
    if (!hadFocus || !panel?.isConnected || document.activeElement !== document.body) return;
    const target = trigger.isConnected && !trigger.disabled ? trigger : panel;
    target.focus({ preventScroll: true });
  };
}
